module.exports = __webpack_public_path__ + "static/media/inner-banner.e5d44fbb.jpg";